import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({providedIn:'root'})
export class RootComponentObserverService {
    public loadUserProfileInfo = new Subject();
    public loadSelectedLanguage = new Subject();
    
    constructor(){}
}